const meta = {auth: true}

const flag = JSON.parse(process.env.VUE_APP_ROUTE_CONFIG_LOADING_TRUE || "false")

const routes: any[] = [
    {path: '', redirect: flag ? '/loading' : '/login', hidden: true},
    {path: '/:catchAll(.*)', name: 'notFound', hidden: true, redirect: '404'},
    {
        path: '/404',
        name: '404',
        hidden: true,
        component: () => import(/* webpackChunkName: "login" */'@/views/NotFound.vue')
    },
    {
        path: '/loading',
        name: '加载中',
        hidden: true,
        component: () => import(/* webpackChunkName: "login" */'@/views/Loading.vue')
    },
    {
        path: '/redirect',
        name: '重定向',
        hidden: true,
        component: () => import(/* webpackChunkName: "login" */'@/views/Redirect.vue')
    },
    {
        path: '/login',
        name: '登录',
        hidden: true,
        component: () => import(/* webpackChunkName: "login" */'@/views/Login.vue')
    },
    {
        path: '/logout',
        name: '登出',
        hidden: true,
        component: () => import(/* webpackChunkName: "login" */'@/views/Logout.vue')
    },
    {
        path: '/table-span-test',
        name: '表格测试',
        hidden: true,
        component: () => import(/* webpackChunkName: "login" */'@/views/TableSpanTest.vue')
    },
    {
        path: '/index',
        name: '首页',
        meta,
        component: () => import(/* webpackChunkName: "group-base" */'@/views/Index.vue'),
        children: [
            {
                name: 'workbench',
                path: '/workbench',
                meta: {...meta, title: '工作台'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/Workbench/Workbench.vue'),
            },
            {
                name: 'word-list',
                path: '/word-list',
                meta: {...meta, title: '单词表'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/Word/WordList.vue'),
            },
            {
                name: 'clock-statistic',
                path: '/clock-statistic',
                meta: {...meta, title: '打卡统计'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/ClockIn/ClockInStatistic.vue'),
            },
            {
                name: 'recite-statistic',
                path: '/recite-statistic',
                meta: {...meta, title: '学习统计'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/Word/ReciteStatistic.vue'),
            },
            {
                name: 'recite-record',
                path: '/recite-record',
                meta: {...meta, title: '背诵记录'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/Word/ReciteRecord.vue'),
            },
            {
                name: 'mobile-user',
                path: '/mobile-user',
                meta: {...meta, title: '移动用户'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/MobileUser/MobileUser.vue'),
            },
            {
                name: 'book-list',
                path: '/book-list',
                meta: {...meta, title: '单词本'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/Word/WordBook.vue'),
            },
            {
                name: 'book-word-list',
                path: '/book-word-list',
                meta: {...meta, title: '单词管理'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/Word/WordManageList.vue'),
            },
            {
                name: 'learn-record',
                path: '/learn-record',
                meta: {...meta, title: '背诵记录'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/Word/LearnRecord.vue'),
            },
            {
                name: 'book-group-list',
                path: '/book-group-list',
                meta: {...meta, title: '单词本合集'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/Word/WordBookGroup.vue'),
            },
            {
                name: 'book-detail',
                path: '/book-detail/:id',
                meta: {...meta, title: '单词本详情'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/Word/WordBookDetail.vue'),
            },
            {
                name: 'custom-manage',
                path: '/custom-manage',
                meta: {...meta, title: '客户管理'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/CustomManage/customManage.vue'),
            },
            {
                name: 'custom-detail',
                path: '/custom-detail/:id',
                meta: {...meta, title: '客户详情'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/CustomManage/customDetail.vue'),

            },
            {
                name: 'custom-add',
                path: '/custom-add',
                meta: {...meta, title: '客户新增'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/CustomManage/customAdd.vue'),
            },
            {
                name: 'project-reserve',
                path: '/project-reserve/:type',
                meta: {...meta, title: '项目储备'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/ProjectReserve/ProjectReserve.vue'),
            },
            {
                name: 'project-reserve-detail',
                path: '/project-reserve-detail/:id',
                meta: {...meta, title: '项目储备详情'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/ProjectReserve/ProjectReserveDetail.vue'),
            },
            {
                name: 'protocol-add',
                path: '/protocol-add',
                meta: {...meta, title: '投资协议表'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/ProjectReserve/ProtocolAdd.vue'),
            },
            {
                name: 'investment-term-detail',
                path: '/investment-term-detail/:pId/:pgId',
                meta: {...meta, title: '投资协议详情'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/ProjectReserve/InvestmentTermDetail.vue'),
            },
            {
                name: 'risk-manage',
                path: '/risk-manage',
                meta: {...meta, title: '风险管理'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/RiskManage/riskManage.vue'),
            },
            {
                name: 'angel-fund-project-manage',
                path: '/angel-fund-project-manage',
                meta: {...meta, title: '天使基金项目管理'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/AngelFund/angelFundProject.vue'),
            },
            {
                name: 'angel-fund-organ-manage',
                path: '/angel-fund-organ-manage',
                meta: {...meta, title: '天使基金机构管理'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/AngelFund/angelFundOrgan.vue'),
            },
            {
                name: 'fund-type-manage',
                path: '/fund-type-manage',
                meta: {...meta, title: '基金类型管理'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/AngelFund/fundType.vue'),
            },
            {
                name: 'department-daily-work',
                path: '/department-daily-work',
                meta: {...meta, title: '部门日常工作'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/DailyWork/departmentDailyWork.vue'),
            },
            {
                name: 'personal-daily-work',
                path: '/personal-daily-work',
                meta: {...meta, title: '个人日常工作'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/DailyWork/personalDailyWork.vue'),
            },
            {
                name: 'borrowing-manage',
                path: '/borrowing-manage',
                meta: {...meta, title: '借阅管理'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/BorrowingManage/borrowingManage.vue'),
            },
            {
                name: 'data-dictionary',
                path: '/data-dictionary',
                meta: {...meta, title: '字典管理'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/DataDictionary/dataDictionary.vue'),
            },
            // {
            //     name: 'data-dictionary-detail',
            //     path: '/data-dict-detail/:id',
            //     meta: { ...meta, title: '字典配置' },
            //     component: () => import(/* webpackChunkName: "group-base" */'@/views/DataDictionary/dataDictDetail.vue'),
            // },
            {
                name: 'department-manage',
                path: '/department-manage',
                meta: {...meta, title: '部门管理'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/DepartmentManage/departmentManage.vue'),
            },
            {
                name: 'department-contracts',
                path: '/department-contracts',
                meta: {...meta, title: '通讯录'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/DepartmentManage/departmentContracts.vue'),
            },
            {
                name: 'resource-management',
                path: '/resource-management',
                meta: {...meta, title: '资源管理'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/PermissionManagement/ResourceManagement.vue'),
            },
            {
                name: 'role-config',
                path: '/role-config',
                meta: {...meta, title: '角色管理'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/PermissionManagement/RoleConfig.vue'),
            },
            {
                name: 'user-manager',
                path: '/user-management',
                meta: {...meta, title: '用户管理'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/PermissionManagement/UserManager.vue'),
            },
            {
                name: 'post-management',
                path: '/post-management',
                meta: {...meta, title: '岗位管理'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/PermissionManagement/PostManagement.vue'),
            },
            {
                path: '/information-center',
                name: 'information-center',
                meta: {...meta, title: '我的消息'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/Information/center/InformationCenter.vue'),
            },
            {
                path: '/information-template',
                name: 'information-template',
                meta: {...meta, title: '消息模板配置'},
                component: () => import(/* webpackChunkName: "group-8" */'@/views/Information/template/InformationTemplate.vue'),
            },
            {
                path: '/sms-template',
                name: 'sms-template',
                meta: {...meta, title: '短信模板配置'},
                component: () => import(/* webpackChunkName: "group-8" */'@/views/Information/template/SmsTemplate.vue'),
            },
            {
                path: '/one-step-investigation',
                name: 'one-step-investigation',
                meta: {...meta, title: '一键背调'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/BackgroundInvestigation/OneStepInvestigation.vue'),
            },
            {
                path: '/enter-investigation',
                name: 'enter-investigation',
                meta: {...meta, title: '企业背调'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/BackgroundInvestigation/EnterInvestigation.vue'),
            },
            {
                path: '/enter-investigation-detail',
                name: 'enter-investigation-detail',
                meta: {...meta, title: '企业背调详情'},
                component: () => import(/* webpackChunkName: "group-base" */'@/views/BackgroundInvestigation/EnterInvestigationDetail.vue'),
            }
        ]
    },
];
export default routes;
